import {createSlice} from "@reduxjs/toolkit";

const initialbannerlogState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [], 
  timeSlotlist: [],
  deletedTimeSlot: {}
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const BannerLogSlice = createSlice({
  
    name: "bannerlog",
    initialState: initialbannerlogState,
    reducers: {
      catchError: (state, action) => {
        state.error = `${action.type}: ${action.payload.error}`;
        if (action.payload.callType === callTypes.list) {
          state.listLoading = false;
        } else {
          state.actionsLoading = false;
        }
      },
      startCall: (state, action) => {
        state.error = null;
        if (action.payload.callType === callTypes.list) {
          state.listLoading = true;
        } else {
          state.actionsLoading = true;
        }
      },
      clearfetchStaffUsers: (state, action) => {
        state.listLoading = false;
        state.error = null;
        state.entities = [];
        state.totalCount = 0;
      },
      emptyList: (state, action) => {
        state.error = null;
        state.entities = [];
        // state.totalCount = 0;
        state.exportData = [];
      },
      // getstaffUserById
      timeSlotList: (state, action) => {
        const { totalCount, entities } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.entities = entities;
        state.totalCount = totalCount;
      },
      bannerExport: (state, action) => {
        const { exportData } = action.payload;
        // state.listLoading = false;
        // state.error = null;
        state.exportData = exportData;
      },  
    }
});